import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { Link } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useState } from "react";
import { FaCirclePlus, FaCircleMinus } from "react-icons/fa6";
import { addDoc, collection } from "firebase/firestore";
import { toast } from "react-toastify";
import CountrySelectInput from "../shared/countrySelectInput";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../../config/firebase";
import DashboardLayout from "../layout";

function CreateQoute() {
  const obj = {
    ative: true,
    content: "Create Qoute",
  };

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const [loading, setLoading] = useState(false);
  const [formCount, setFormCount] = useState(0);

  const [showForm, setShowForm] = useState(true);
  const [showInvoice, setShowInvoice] = useState(false);

  const handleButtonClick = (buttonType) => {
    if (buttonType === "form") {
      setShowForm(true);
      setShowInvoice(false);
    } else if (buttonType === "invoice") {
      setShowForm(false);
      setShowInvoice(true);
    }
  };

  const handlePlusClick = () => {
    setFormCount(formCount + 1);
  };

  const handleMinusClick = () => {
    setFormCount(formCount - 1);
  };

  const [formData, setFormData] = useState({
    status: "pending",
    name: "",
    email: "",
    companyName: "",
    state: "",
    zipCode: "",
    houseNo: "",
    address: "",
    country: "",
    city: "",
    phoneNo: "",
    file: null,
    pcsType: "",
    pcsPackage: "",
    weight: "",
    length: "",
    width: "",
    height: "",
    serviceType: "",
    creationDate: new Date().toISOString(),
    orderDetails: [
      {
        number: "",
        description: "",
        price: "",
        exclVAT: "",
      },
    ],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleOrderDetailsChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const updatedServices = [...prevData.orderDetails];
      updatedServices[index][field] = value;

      return {
        ...prevData,
        orderDetails: updatedServices,
      };
    });
  };
  // console.log(formData)
  const handleFileChange = async (e, fileType) => {
    const fileInput = e.target;
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      console.error("No file selected.");
      return;
    }

    const file = fileInput.files[0];

    if (file) {
      try {
        setLoading(true);
        const storageRef = ref(storage, `quoteFile/${fileType}/${file.name}`);
        await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(storageRef);

        setFormData((prevData) => ({
          ...prevData,
          [fileType]: downloadURL,
        }));
      } catch (error) {
        console.error("Error uploading file:", error);
        toast.error("Error uploading file: " + error.message);
      } finally {
        setLoading(false);
      }
    }
  };
  const handleAddData = async (e) => {
    e.preventDefault(); // Prevent form submission from reloading the page
    // console.log(formData);
    try {
      setLoading(true);
      await Promise.all([
        formData.file && handleFileChange(formData.file, "file"),
      ]);
      const usersCollection = collection(db, "quotes"); // Changed to 'users' collection
      await addDoc(usersCollection, formData);
      toast.success("Quotes data saved successfully!");
      window.location.reload();
      // Consider resetting form or redirecting instead of reloading
      // setUserData({ name: '', email: '', password: '' });
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddMore = () => {
    setFormCount(formCount + 1);

    setFormData((prevData) => ({
      ...prevData,
      orderDetails: [...prevData.orderDetails, {}],
    }));
  };

  // console.log(formData);

  return (
    <>
      <DashboardLayout>
        {/* <div className="hidden sm:block">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full border border-red">
          <Header title="Create Qoute" />
          <div className="p-4 bg-cus-gray">
            <div className="p-4 mx-auto bg-white border rounded-md">
              <div className="">
                <div>
                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="HTML"
                    onClick={() => handleButtonClick("form")}
                    className="mr-2"
                    checked={showForm}
                  />
                  <label for="html" className="mr-4">
                    From
                  </label>

                  <input
                    type="radio"
                    id="html"
                    name="fav_language"
                    value="HTML"
                    className="mr-2"
                    onClick={() => handleButtonClick("invoice")}
                  />
                  <label for="html" className="mr-4">
                    Invoice
                  </label>
                </div>

                <div>
                  {showForm && (
                    <div>
                      {/* Collection */}
                      {/* Collection */}
                      {/* Collection */}
                      <h2 className="mx-[30px] font-bold text-xl mt-4">
                        Collection address{" "}
                      </h2>
                      <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="name"
                          >
                            Name
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="name"
                            onChange={handleInputChange}
                            value={formData.name}
                            name="name"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="companyname"
                          >
                            company Name
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="companyName"
                            onChange={handleInputChange}
                            value={formData.companyName}
                            name="companyName"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="addressone"
                          >
                            Address
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="address"
                            // id="address"
                            onChange={handleInputChange}
                            value={formData.address}
                            name="address"
                          />
                        </div>
                        {/* <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="addresstwo"
                          >
                            Address line 2
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="addresstwo"
                          />
                        </div> */}
                        <div className="flex flex-col gap-1 py-2">
                          <CountrySelectInput
                            label="Country"
                            onChange={handleInputChange}
                            value={formData.country}
                            name="country"
                            id="country"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="state"
                          >
                            State
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="state"
                            onChange={handleInputChange}
                            value={formData.state}
                            name="state"
                          />
                        </div>
                      </div>
                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            Zip Code
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="zipCode"
                            onChange={handleInputChange}
                            value={formData.zipCode}
                            name="zipCode"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2 ">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            City
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="city"
                            onChange={handleInputChange}
                            value={formData.city}
                            name="city"
                          />
                        </div>
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="Mblenum"
                          >
                            Mobile Number
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="phoneNo"
                            onChange={handleInputChange}
                            value={formData.moileNo}
                            name="phoneNo"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] grid md:grid-cols-3 grid-cols-1 gap-3">
                        <div className="flex flex-col gap-1 py-2">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            Lenght
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="length"
                            onChange={handleInputChange}
                            value={formData.length}
                            name="length"
                          />
                        </div>
                        <div className="flex flex-col py-3 ga2-4">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            Width
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="width"
                            onChange={handleInputChange}
                            value={formData.width}
                            name="width"
                          />
                        </div>{" "}
                        <div className="flex flex-col py-3 ga2-4">
                          <label
                            className="w-full text-sm font-normal "
                            htmlFor="username"
                          >
                            Height
                          </label>
                          <input
                            type="text"
                            className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                            id="height"
                            onChange={handleInputChange}
                            value={formData.height}
                            name="height"
                          />
                        </div>
                      </div>

                      <div className="mx-[30px] mt-2">
                        <input
                          type="file"
                          id="file"
                          name="file"
                          onChange={(e) => handleFileChange(e, "file")}
                        />
                      </div>

                      {/* {items} */}
                      <div>
                        <div className="mx-[30px] flex items-center mt-8 gap-4">
                          <h2 className="text-xl font-bold ">Item details</h2>
                          <FaCirclePlus
                            className="text-[22px] text-[#03336e]"
                            onClick={handleAddMore}
                          />
                        </div>

                        {formCount === 0 ? (
                          <p className="mx-[30px] mt-3 text-[12px]">
                            You don't have any item details
                          </p>
                        ) : (
                          <>
                            {formData.orderDetails.map((formItem, index) => (
                              <div className="mx-[30px]" key={index}>
                                <h2 className="flex gap-3 items-center text-[16px] font-bold text-[gray] mt-6">
                                  Item details
                                  <FaCircleMinus
                                    onClick={() => handleMinusClick()}
                                  />
                                </h2>
                                <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                                  <div className="flex flex-col gap-1 py-2">
                                    <label
                                      className="w-full text-sm font-normal"
                                      htmlFor={`itemName_${index}`}
                                    >
                                      Item Name
                                    </label>
                                    <input
                                      type="text"
                                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                      id={`itemName_${index}`}
                                      onChange={(e) =>
                                        handleOrderDetailsChange(
                                          index,
                                          "itemName",
                                          e
                                        )
                                      }
                                      value={formItem.itemName || ""}
                                      name={`itemName_${index}`}
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1 py-2">
                                    <label
                                      className="w-full text-sm font-normal"
                                      htmlFor={`itemValue_${index}`}
                                    >
                                      Item Value
                                    </label>
                                    <input
                                      type="text"
                                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                      id={`itemValue_${index}`}
                                      onChange={(e) =>
                                        handleOrderDetailsChange(
                                          index,
                                          "itemValue",
                                          e
                                        )
                                      }
                                      value={formItem.itemValue || ""}
                                      name={`itemValue_${index}`}
                                    />
                                  </div>
                                </div>

                                <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                                  <div className="flex flex-col gap-1 py-2">
                                    <label
                                      className="w-full text-sm font-normal"
                                      htmlFor={`dimensions_${index}`}
                                    >
                                      Dimensions
                                    </label>
                                    <input
                                      type="text"
                                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                      id={`dimensions_${index}`}
                                      onChange={(e) =>
                                        handleOrderDetailsChange(
                                          index,
                                          "dimensions",
                                          e
                                        )
                                      }
                                      value={formItem.dimensions || ""}
                                      name={`dimensions_${index}`}
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1 py-2">
                                    <label
                                      className="w-full text-sm font-normal"
                                      htmlFor={`pkgType_${index}`}
                                    >
                                      Select Package Type*
                                    </label>
                                    <select
                                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                      id={`pkgType_${index}`}
                                      onChange={(e) =>
                                        handleOrderDetailsChange(
                                          index,
                                          "pkgType",
                                          e
                                        )
                                      }
                                      value={formItem.pkgType || ""}
                                      name={`pkgType_${index}`}
                                    >
                                      <option value="parsel">Parsel</option>
                                      <option value="cargo">Cargo</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3"></div>
                                {/* <button
                              className="mx-[30px] mt-4 bg-cus-blue rounded-md text-white p-2 text-sm md:w-[200px] w-[180px]"
                              onClick={() => handleSend(index)}
                            >
                              Send
                            </button> */}
                              </div>
                            ))}
                          </>
                        )}

                        {/* Removed 'Save as new addres book entry' heading */}
                        {/* Collection */}
                        {/* Collection */}

                        <div>
                          <h2 className="mx-[30px] font-bold text-xl mt-8">
                            Delivery address
                          </h2>
                          <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                            <div className="flex flex-col gap-1 py-2">
                              <label
                                className="w-full text-sm font-normal "
                                htmlFor="value"
                              >
                                Value
                              </label>
                              <input
                                type="text"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                id="value"
                                onChange={handleInputChange}
                                value={formData.value}
                                name="value"
                              />
                            </div>
                            <div className="flex flex-col gap-1 py-2">
                              <label
                                className="w-full text-sm font-normal "
                                htmlFor="weight"
                              >
                                Weight
                              </label>
                              <input
                                type="text"
                                className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                id="weigth"
                                onChange={handleInputChange}
                                value={formData.weigth}
                                name="weigth"
                              />
                            </div>
                          </div>
                          <div className="mx-[30px] flex flex-col gap-1 py-2">
                            <label
                              className="w-full text-sm font-normal "
                              htmlFor="username"
                            >
                              Select Package Type*
                            </label>
                            <select
                              className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                              id="PkgType"
                              onChange={handleInputChange}
                              value={formData.PkgType}
                              name="PkgType"
                            >
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                            </select>
                          </div>

                          <div className="mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                            <div className="flex flex-col gap-1 py-2">
                              <label
                                className="w-full text-sm font-normal "
                                htmlFor="username"
                              >
                                Services
                              </label>
                              <select
                                placeholder="Select"
                                className="w-full h-8 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                id="serviceType"
                                onChange={handleInputChange}
                                value={formData.serviceType}
                                name="serviceType"
                              >
                                <option> Select</option>
                                <option> IOR</option>
                                <option> White glove</option>
                                <option> EOR</option>
                                <option> other</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="mx-[30px] py-4 w-full flex flex-col gap-3">
                          <div className="flex items-center gap-3">
                            <input type="checkbox" className="" />
                            <label
                              className=" font-normal text-[10px] w-full"
                              htmlFor="chkbox"
                            >
                              By clicking i agree all terms and conditions.
                            </label>
                          </div>
                          {/* Removed EOR guarantee checkbox */}

                          <div className="flex items-center gap-3">
                            <input type="checkbox" className="" />

                            <label
                              className=" font-normal text-[10px] w-full"
                              htmlFor="chkbox"
                            >
                              Option
                            </label>
                          </div>
                        </div>
                        <div className=" flex justify-center items-center md:justify-start md:mx-[30px]">
                          <button
                            onClick={handleAddData}
                            className=" bg-cus-blue rounded-md text-white p-2 text-sm md:w-[341px] w-[180px]"
                          >
                            {" "}
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {showInvoice && (
                    <div>
                      {" "}
                      <div
                        {...getRootProps()}
                        className="cursor-pointer active:opacity-70 font-semibold flex justify-center items-center border-2 h-[92px] mt-5 border-dashed  border-[#053F924A]"
                      >
                        <input {...getInputProps()} />
                        <p className="text-[10px] md:text-[15px] text-black">
                          {acceptedFiles.length > 0
                            ? `File: ${acceptedFiles[0].name}`
                            : "Drag file here to upload"}
                        </p>
                      </div>
                      {/* send button */}
                      <Link to="/quoteadmindetails">
                        <button className="mt-5 mx-[30px] bg-cus-blue rounded-md text-white p-2 text-sm md:w-[341px] w-[180px]">
                          Send
                        </button>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
}

export default CreateQoute;
